// if (!customElements.get('custom-select')) {
//   class CustomSelect extends HTMLElement {
//     constructor() {
//       super();
//       this.button = this.querySelector('.custom-select__btn');
//       this.listbox = this.querySelector('.custom-select__listbox');
//       this.selectedOption = this.querySelector('[aria-selected="true"]');

//       // Set the selected option.
//       if (!this.selectedOption) {
//         this.selectedOption = this.listbox.firstElementChild;
//       }

//       this.setButtonWidth();
//       window.initLazyScript(this, this.init.bind(this));
//     }

//     init() {
//       this.options = this.querySelectorAll('.custom-select__option');
//       this.nativeSelect = document.getElementById(`${this.id}-native`);
//       this.swatches = !!Array.from(this.options).find((el) => 'swatch' in el.dataset);
//       this.focusedClass = 'is-focused';
//       this.searchString = '';
//       this.listboxOpen = false;
//       this.selectedOption = this.querySelector('[aria-selected="true"]');

//       // Set the selected option.
//       if (!this.selectedOption) {
//         this.selectedOption = this.listbox.firstElementChild;
//       }

//       // -------------------- AUTO SELECT FIRST OPTION WITH data-value-id --------------------
//       const firstDataValueOption = Array.from(this.options).find(opt => opt.dataset.valueId);
//       if (firstDataValueOption) {
//         console.log('Auto-selecting first option with data-value-id:', firstDataValueOption.textContent);
//         this.selectOption(firstDataValueOption); // triggers existing selectOption logic & events
//       } else {
//         console.log('No option found with data-value-id, defaulting to first element.');
//         this.selectOption(this.selectedOption);
//       }
//       // -----------------------------------------------------------------------------------

//       this.addEventListener('keydown', this.handleKeydown.bind(this));
//       this.button.addEventListener('mousedown', this.handleMousedown.bind(this));
//     }

//     static getNextVisibleSibling(elem) {
//       let sibling = elem.nextElementSibling;
//       while (sibling) {
//         if (sibling.offsetParent) return sibling;
//         sibling = sibling.nextElementSibling;
//       }
//       return null;
//     }

//     static getPreviousVisibleSibling(elem) {
//       let sibling = elem.previousElementSibling;
//       while (sibling) {
//         if (sibling.offsetParent) return sibling;
//         sibling = sibling.previousElementSibling;
//       }
//       return null;
//     }

//     addListboxOpenListeners() {
//       this.mouseoverHandler = this.handleMouseover.bind(this);
//       this.mouseleaveHandler = this.handleMouseleave.bind(this);
//       this.clickHandler = this.handleClick.bind(this);
//       this.blurHandler = this.handleBlur.bind(this);

//       this.listbox.addEventListener('mouseover', this.mouseoverHandler);
//       this.listbox.addEventListener('mouseleave', this.mouseleaveHandler);
//       this.listbox.addEventListener('click', this.clickHandler);
//       this.listbox.addEventListener('blur', this.blurHandler);
//     }

//     removeListboxOpenListeners() {
//       this.listbox.removeEventListener('mouseover', this.mouseoverHandler);
//       this.listbox.removeEventListener('mouseleave', this.mouseleaveHandler);
//       this.listbox.removeEventListener('click', this.clickHandler);
//       this.listbox.removeEventListener('blur', this.blurHandler);
//     }

//     handleKeydown(evt) {
//       if (this.listboxOpen) {
//         this.handleKeyboardNav(evt);
//       } else if (evt.key === 'ArrowUp' || evt.key === 'ArrowDown' || evt.key === ' ') {
//         evt.preventDefault();
//         this.showListbox();
//       }
//     }

//     handleMousedown(evt) {
//       if (!this.listboxOpen && evt.button === 0) {
//         this.showListbox();
//       }
//     }

//     handleMouseover(evt) {
//       if (evt.target.matches('li')) {
//         this.focusOption(evt.target);
//       }
//     }

//     handleMouseleave() {
//       this.focusOption(this.selectedOption);
//     }

//     handleClick(evt) {
//       if (evt.target.tagName === 'LI') {
//         console.log('Clicked option:', evt.target.textContent);
//         this.selectOption(evt.target);
//       }
//     }

//     handleBlur() {
//       if (this.listboxOpen) {
//         this.hideListbox();
//       }
//     }

//     handleKeyboardNav(evt) {
//       let optionToFocus;

//       if (evt.key === 'Tab') {
//         evt.preventDefault();
//       }

//       switch (evt.key) {
//         case 'ArrowUp':
//         case 'ArrowDown':
//           evt.preventDefault();
//           optionToFocus = (evt.key === 'ArrowUp')
//             ? CustomSelect.getPreviousVisibleSibling(this.focusedOption)
//             : CustomSelect.getNextVisibleSibling(this.focusedOption);

//           if (optionToFocus && !optionToFocus.classList.contains('is-disabled')) {
//             this.focusOption(optionToFocus);
//           }
//           break;

//         case 'Enter':
//         case ' ':
//           evt.preventDefault();
//           this.selectOption(this.focusedOption);
//           break;

//         case 'Escape':
//           evt.preventDefault();
//           this.hideListbox();
//           break;

//         default:
//           optionToFocus = this.findOption(evt.key);
//           if (optionToFocus) {
//             this.focusOption(optionToFocus);
//           }
//           break;
//       }
//     }

//     setButtonWidth() {
//       const getHorizontalPadding = (el) => {
//         const elStyle = getComputedStyle(el);
//         return parseFloat(elStyle.paddingLeft) + parseFloat(elStyle.paddingRight);
//       };

//       const buttonPadding = getHorizontalPadding(this.button);
//       const optionPadding = getHorizontalPadding(this.selectedOption);
//       const buttonBorder = this.button.offsetWidth - this.button.clientWidth;
//       const optionWidth = Math.ceil(this.selectedOption.getBoundingClientRect().width);

//       this.button.style.setProperty('--custom-select-button-width', `${optionWidth - optionPadding + buttonPadding + buttonBorder}px`);
//     }

//     showListbox() {
//       this.listbox.hidden = false;
//       this.listboxOpen = true;

//       this.classList.add('is-open');
//       this.button.setAttribute('aria-expanded', 'true');
//       this.listbox.setAttribute('aria-hidden', 'false');

//       setTimeout(() => {
//         this.focusOption(this.selectedOption);
//         this.listbox.focus();

//         this.addListboxOpenListeners();
//       });
//     }

//     hideListbox() {
//       if (!this.listboxOpen) return;

//       this.listbox.hidden = true;
//       this.listboxOpen = false;

//       this.classList.remove('is-open');
//       this.button.setAttribute('aria-expanded', 'false');
//       this.listbox.setAttribute('aria-hidden', 'true');

//       if (this.focusedOption) {
//         this.focusedOption.classList.remove(this.focusedClass);
//         this.focusedOption = null;
//       }

//       this.button.focus();
//       this.removeListboxOpenListeners();
//     }

//     findOption(key) {
//       this.searchString += key;

//       if (this.searchTimer) {
//         clearTimeout(this.searchTimer);
//       }

//       this.searchTimer = setTimeout(() => {
//         this.searchString = '';
//       }, 500);

//       return Array.from(this.options).find(option => {
//         const label = option.innerText.toLowerCase();
//         return label.includes(this.searchString) && !option.classList.contains('is-disabled');
//       });
//     }

//     focusOption(option) {
//       if (this.focusedOption) {
//         this.focusedOption.classList.remove(this.focusedClass);
//       }

//       this.focusedOption = option;
//       this.focusedOption.classList.add(this.focusedClass);

//       if (this.listbox.scrollHeight > this.listbox.clientHeight) {
//         const scrollBottom = this.listbox.clientHeight + this.listbox.scrollTop;
//         const optionBottom = option.offsetTop + option.offsetHeight;

//         if (optionBottom > scrollBottom) {
//           this.listbox.scrollTop = optionBottom - this.listbox.clientHeight;
//         } else if (option.offsetTop < this.listbox.scrollTop) {
//           this.listbox.scrollTop = option.offsetTop;
//         }
//       }
//     }

//     selectOption(option) {
//       console.log('Selecting option:', option.textContent);

//       if (option !== this.selectedOption) {
//         option.setAttribute('aria-selected', 'true');
//         this.selectedOption.setAttribute('aria-selected', 'false');

//         if (this.swatches) {
//           this.button.dataset.swatch = option.dataset.swatch || '';
//           const nativeSwatchColor = option.style.getPropertyValue('--native-swatch-color');
//           if (nativeSwatchColor) {
//             this.button.style.setProperty('--native-swatch-color', nativeSwatchColor);
//             this.button.style.setProperty('--native-swatch-image', '');
//           }
//           const nativeSwatchImage = option.style.getPropertyValue('--native-swatch-image');
//           if (nativeSwatchImage) {
//             this.button.style.setProperty('--native-swatch-image', nativeSwatchImage);
//             this.button.style.setProperty('--native-swatch-color', '');
//           }
//         }

//         this.button.firstElementChild.textContent = option.firstElementChild.textContent;
//         this.listbox.setAttribute('aria-activedescendant', option.id);
//         this.selectedOption = document.getElementById(option.id);

//         if (this.nativeSelect) {
//           this.nativeSelect.value = option.dataset.value;
//           this.nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
//         } else {
//           const detail = {
//             selectedValue: option.dataset.value,
//             productUrl: option.dataset.productUrl
//           };
//           this.dispatchEvent(new CustomEvent('change', { bubbles: true, detail }));
//         }
//       }

//       this.hideListbox();
//     }
//   }

//   customElements.define('custom-select', CustomSelect);
// }


if (!customElements.get('custom-select')) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.custom-select__btn');
      this.listbox = this.querySelector('.custom-select__listbox');
      this.selectedOption = this.querySelector('[aria-selected="true"]');

      // Set the selected option.
      if (!this.selectedOption) {
        this.selectedOption = this.listbox.firstElementChild;
      }

      this.setButtonWidth();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.options = this.querySelectorAll('.custom-select__option');
      this.nativeSelect = document.getElementById(`${this.id}-native`);
      this.swatches = !!Array.from(this.options).find((el) => 'swatch' in el.dataset);
      this.focusedClass = 'is-focused';
      this.searchString = '';
      this.listboxOpen = false;
      this.selectedOption = this.querySelector('[aria-selected="true"]');

      // Set the selected option.
      if (!this.selectedOption) {
        this.selectedOption = this.listbox.firstElementChild;
      }

      this.addEventListener('keydown', this.handleKeydown.bind(this));
      this.button.addEventListener('mousedown', this.handleMousedown.bind(this));

      // -------------------- AUTO SELECT FIRST OPTION WITH data-value-id --------------------
      const autoSelectFirstOption = () => {
        const firstDataValueOption = Array.from(this.options).find(opt => opt.dataset.valueId);
        if (firstDataValueOption) {
          // console.log('Auto-selecting first option with data-value-id:', firstDataValueOption.textContent);
          this.selectOption(firstDataValueOption); // triggers existing selectOption logic & events
          clearInterval(autoSelectInterval); // stop checking once selected
        } else {
          // console.log('Waiting for options to be rendered...');
        }
      };

      // Poll every 100ms until options are available
      const autoSelectInterval = setInterval(autoSelectFirstOption, 100);
    }

    static getNextVisibleSibling(elem) {
      let sibling = elem.nextElementSibling;
      while (sibling) {
        if (sibling.offsetParent) return sibling;
        sibling = sibling.nextElementSibling;
      }
      return null;
    }

    static getPreviousVisibleSibling(elem) {
      let sibling = elem.previousElementSibling;
      while (sibling) {
        if (sibling.offsetParent) return sibling;
        sibling = sibling.previousElementSibling;
      }
      return null;
    }

    addListboxOpenListeners() {
      this.mouseoverHandler = this.handleMouseover.bind(this);
      this.mouseleaveHandler = this.handleMouseleave.bind(this);
      this.clickHandler = this.handleClick.bind(this);
      this.blurHandler = this.handleBlur.bind(this);

      this.listbox.addEventListener('mouseover', this.mouseoverHandler);
      this.listbox.addEventListener('mouseleave', this.mouseleaveHandler);
      this.listbox.addEventListener('click', this.clickHandler);
      this.listbox.addEventListener('blur', this.blurHandler);
    }

    removeListboxOpenListeners() {
      this.listbox.removeEventListener('mouseover', this.mouseoverHandler);
      this.listbox.removeEventListener('mouseleave', this.mouseleaveHandler);
      this.listbox.removeEventListener('click', this.clickHandler);
      this.listbox.removeEventListener('blur', this.blurHandler);
    }

    handleKeydown(evt) {
      if (this.listboxOpen) {
        this.handleKeyboardNav(evt);
      } else if (evt.key === 'ArrowUp' || evt.key === 'ArrowDown' || evt.key === ' ') {
        evt.preventDefault();
        this.showListbox();
      }
    }

    handleMousedown(evt) {
      if (!this.listboxOpen && evt.button === 0) {
        this.showListbox();
      }
    }

    handleMouseover(evt) {
      if (evt.target.matches('li')) {
        this.focusOption(evt.target);
      }
    }

    handleMouseleave() {
      this.focusOption(this.selectedOption);
    }

    handleClick(evt) {
      if (evt.target.tagName === 'LI') {
        console.log('LI clicked:', evt.target.textContent);
        this.selectOption(evt.target);
      }
    }

    handleBlur() {
      if (this.listboxOpen) {
        this.hideListbox();
      }
    }

    handleKeyboardNav(evt) {
      let optionToFocus;

      if (evt.key === 'Tab') {
        evt.preventDefault();
      }

      switch (evt.key) {
        case 'ArrowUp':
        case 'ArrowDown':
          evt.preventDefault();
          optionToFocus = evt.key === 'ArrowUp' ? CustomSelect.getPreviousVisibleSibling(this.focusedOption) : CustomSelect.getNextVisibleSibling(this.focusedOption);
          if (optionToFocus && !optionToFocus.classList.contains('is-disabled')) {
            this.focusOption(optionToFocus);
          }
          break;
        case 'Enter':
        case ' ':
          evt.preventDefault();
          this.selectOption(this.focusedOption);
          break;
        case 'Escape':
          evt.preventDefault();
          this.hideListbox();
          break;
        default:
          optionToFocus = this.findOption(evt.key);
          if (optionToFocus) {
            this.focusOption(optionToFocus);
          }
          break;
      }
    }

    setButtonWidth() {
      const getHorizontalPadding = (el) => {
        const elStyle = getComputedStyle(el);
        return parseFloat(elStyle.paddingLeft) + parseFloat(elStyle.paddingRight);
      };

      const buttonPadding = getHorizontalPadding(this.button);
      const optionPadding = getHorizontalPadding(this.selectedOption);
      const buttonBorder = this.button.offsetWidth - this.button.clientWidth;
      const optionWidth = Math.ceil(this.selectedOption.getBoundingClientRect().width);

      this.button.style.setProperty('--custom-select-button-width', `${optionWidth - optionPadding + buttonPadding + buttonBorder}px`);
    }

    showListbox() {
      this.listbox.hidden = false;
      this.listboxOpen = true;
      this.classList.add('is-open');
      this.button.setAttribute('aria-expanded', 'true');
      this.listbox.setAttribute('aria-hidden', 'false');

      setTimeout(() => {
        this.focusOption(this.selectedOption);
        this.listbox.focus();
        this.addListboxOpenListeners();
      });
    }

    hideListbox() {
      if (!this.listboxOpen) return;

      this.listbox.hidden = true;
      this.listboxOpen = false;
      this.classList.remove('is-open');
      this.button.setAttribute('aria-expanded', 'false');
      this.listbox.setAttribute('aria-hidden', 'true');

      if (this.focusedOption) {
        this.focusedOption.classList.remove(this.focusedClass);
        this.focusedOption = null;
      }

      this.button.focus();
      this.removeListboxOpenListeners();
    }

    findOption(key) {
      this.searchString += key;
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => { this.searchString = ''; }, 500);

      return Array.from(this.options).find(option => {
        const label = option.innerText.toLowerCase();
        return label.includes(this.searchString) && !option.classList.contains('is-disabled');
      });
    }

    focusOption(option) {
      if (this.focusedOption) this.focusedOption.classList.remove(this.focusedClass);

      this.focusedOption = option;
      this.focusedOption.classList.add(this.focusedClass);

      if (this.listbox.scrollHeight > this.listbox.clientHeight) {
        const scrollBottom = this.listbox.clientHeight + this.listbox.scrollTop;
        const optionBottom = option.offsetTop + option.offsetHeight;

        if (optionBottom > scrollBottom) {
          this.listbox.scrollTop = optionBottom - this.listbox.clientHeight;
        } else if (option.offsetTop < this.listbox.scrollTop) {
          this.listbox.scrollTop = option.offsetTop;
        }
      }
    }

    selectOption(option) {
      if (option !== this.selectedOption) {
        option.setAttribute('aria-selected', 'true');
        this.selectedOption.setAttribute('aria-selected', 'false');

        if (this.swatches) {
          this.button.dataset.swatch = option.dataset.swatch || '';
          const nativeSwatchColor = option.style.getPropertyValue('--native-swatch-color');
          if (nativeSwatchColor) {
            this.button.style.setProperty('--native-swatch-color', nativeSwatchColor);
            this.button.style.setProperty('--native-swatch-image', '');
          }
          const nativeSwatchImage = option.style.getPropertyValue('--native-swatch-image');
          if (nativeSwatchImage) {
            this.button.style.setProperty('--native-swatch-image', nativeSwatchImage);
            this.button.style.setProperty('--native-swatch-color', '');
          }
        }

        this.button.firstElementChild.textContent = option.firstElementChild.textContent;
        this.listbox.setAttribute('aria-activedescendant', option.id);
        this.selectedOption = document.getElementById(option.id);

        if (this.nativeSelect) {
          this.nativeSelect.value = option.dataset.value;
          this.nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          const detail = { selectedValue: option.dataset.value, productUrl: option.dataset.productUrl };
          this.dispatchEvent(new CustomEvent('change', { bubbles: true, detail }));
        }
      }

      this.hideListbox();
    }
  }

  customElements.define('custom-select', CustomSelect);
}
